import axios from 'axios';

const cepAlternativeApi3 = axios.create({
  baseURL: `https://api.postmon.com.br/v1/cep`
});

export default cepAlternativeApi3;
